import {createDymistrzCraftAdapter} from './craft-adapter.js';
import {createSmokehouseRuntime} from '../smokehouse/runtime.js';
import * as equipment from '../smokehouse/smoker.js';
import * as capabilities from '../smokehouse/smoker-capabilities.js';
import * as probes from '../smokehouse/thermometer.js';
import * as woodCatalogue from '../smokehouse/wood-catalogue.js';
import * as woodInventory from '../smokehouse/wood-inventory.js';
import * as woodGuidance from '../smokehouse/wood-product-guidance.js';
import * as stages from '../journal/stage.js';
import * as preparation from '../journal/preparation.js';
import * as measurements from '../live/temperature-reading.js';
import * as safety from '../dymek/safety-knowledge.js';

// Product composition boundary; implementations and persisted types stay in place.
export function createDymistrzModule(){
  return Object.freeze({
    craft:createDymistrzCraftAdapter(),
    equipment:Object.freeze({createRuntime:createSmokehouseRuntime,profiles:equipment,capabilities,probes}),
    wood:Object.freeze({catalogue:woodCatalogue,inventory:woodInventory,guidance:woodGuidance}),
    process:Object.freeze({stages,preparation}),
    measurements,
    safety
  });
}
